import React from 'react';

import Register from './Register';

const RegisterGroupon = () => <Register />;

export default RegisterGroupon;
